<template>
    <div id="contenedor-listado-auditoria-contratos-desktop">
    <v-data-table :headers="headers" :items="listadoAuditoriaContratos" :items-per-page="20">
      <template v-slot:[`item.meta`]="{ item }">
       <cortar-texto
       :texto="item.objeto"></cortar-texto>
      </template>
      <template v-slot:[`item.contratista`]="{ item }">
       {{item.contratista? item.contratista : ''}}
      </template>
      <template v-slot:[`item.numero`]="{ item }">
        <span class="font-weight-medium">{{item.numero}}</span>
      </template>
      <template v-slot:[`item.ultimaEstimacionAuditada`]="{ item }">
        <span class="font-weight-light">{{item.ultimaEstimacionAuditada}}</span>
      </template>
      <template v-slot:[`item.porcentajeAvanceAuditado`]="{ item }">
        <span class="font-weight-light" v-if="item.porcentajeAvanceAuditado!==null">
          {{item.porcentajeAvanceAuditado}}%
         </span>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :auditoriaContratos="item"></opciones>
      </template>
      <!--
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
      -->
    </v-data-table>
  </div>
</template>
<script>
import Opciones from './Opciones.vue';
// import FechaHumano from '@/components/FechaHumano.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ListadoAuditoriaContratosDesktop',
  props: {
    listadoAuditoriaContratos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    // FechaHumano,
    CortarTexto,
  },
  data() {
    return {
      headers: [
        { text: 'Ejercicio', value: 'contrato.ejercicio', sortable: true },
        { text: 'Contrato', value: 'numero', sortable: true },
        { text: 'Objeto', value: 'meta', sortable: true },
        { text: 'Contratista', value: 'contratista' },
        { text: 'Última Est.', value: 'ultimaEstimacionAuditada', sortable: true },
        { text: 'Av. Fís.', value: 'porcentajeAvanceAuditado', sortable: true },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
};
</script>
